var _keyMap;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useEffect } from 'react';
import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import "../enums/breakpoints.js";
import "../enums/button.js";
import "../enums/code-editor.js";
import "../enums/colors.js";
import "../enums/combobox.js";
import "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import { Keysets } from "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
var comboboxInputKeys = ['ArrowUp', 'ArrowDown', 'End', 'Home'];
var comboboxDivKeys = [' ', 'Space', 'ArrowUp', 'ArrowDown', 'End', 'Home'];
var keyMap = (_keyMap = {}, _defineProperty(_keyMap, Keysets.ComboboxDiv, comboboxDivKeys), _defineProperty(_keyMap, Keysets.ComboboxInput, comboboxInputKeys), _keyMap);
var preventKeyboardScrollingKeyboardEvent = function preventKeyboardScrollingKeyboardEvent(e) {
  var keyset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Keysets.ComboboxDiv;
  if (keyMap[keyset].includes(e.key)) {
    e.preventDefault();
  }
};
/**
 * Prevent the window from scrolling when using a keyboard to arrow down and up inside of a listbox.
 *
 * @returns void
 */
var usePreventKeyboardScrolling = function usePreventKeyboardScrolling() {
  var keyset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Keysets.ComboboxDiv;
  useEffect(function () {
    var listener = function listener(e) {
      return preventKeyboardScrollingKeyboardEvent(e, keyset);
    };
    window.addEventListener('keydown', listener, false);
    return function () {
      return window.removeEventListener('keydown', listener);
    };
  });
};
export { preventKeyboardScrollingKeyboardEvent, usePreventKeyboardScrolling };